import { PartialQuestThemeData } from "../components/feedbackWorkflow.types";
import { ContactUsInterface, GeneralFeedbackInterface, ScreenHeadings, UiPropsStyleConfigInterface } from "./types";

class FeedbackWorkflowFunctions {
    private ContactUs: ContactUsInterface;
    private GeneralFeedback: GeneralFeedbackInterface;
    private Headers: ScreenHeadings[] | undefined;
    private PrimaryButtonText: string;
    private ReportBug: GeneralFeedbackInterface;
    private RequestFeature: GeneralFeedbackInterface;
    private SecondaryButtonText: string;
    private contactUrl: string;
    private iconColor: string;
    private ratingStyle?: "Star" | "Numbers" | "Smiles";
    private showFooter?: boolean;
    private starBorderColor?: string;
    private starColor?: string;

    constructor(
        ContactUs: ContactUsInterface = {},
        GeneralFeedback: GeneralFeedbackInterface = {},
        Headers: ScreenHeadings[] | undefined = [],
        PrimaryButtonText: string = "",
        ReportBug: GeneralFeedbackInterface = {},
        RequestFeature: GeneralFeedbackInterface = {},
        SecondaryButtonText?: string,
        contactUrl?: string,
        iconColor?: string,
        ratingStyle?: "Star" | "Numbers" | "Smiles",
        showFooter?: boolean,
        starBorderColor?: string,
        starColor?: string,

        // styleConfig?: UiPropsStyleConfigInterface
        // styleConfig: OnboardingStyleConfig = {},
        // questThemeData: PartialQuestThemeData = DEFAULT_QUEST_THEME,
        // brandTheme: PartialBrandTheme = DEFAULT_BRAND_THEME
    ) {
        this.ContactUs = ContactUs;
        this.GeneralFeedback = GeneralFeedback;
        this.Headers = Headers;
        this.PrimaryButtonText = PrimaryButtonText;
        this.ReportBug = ReportBug;
        this.RequestFeature = RequestFeature;
        this.SecondaryButtonText = SecondaryButtonText;
        this.contactUrl = contactUrl;
        this.iconColor = iconColor;
        this.ratingStyle = ratingStyle;
        this.showFooter = showFooter;
        this.starBorderColor = starBorderColor;
        this.starColor = starColor;

        // this.styleConfig = styleConfig;
        // this.styleConfig = styleConfig;
        // this.questThemeData = { ...DEFAULT_QUEST_THEME, ...questThemeData };
        // this.brandTheme = { ...DEFAULT_BRAND_THEME, ...brandTheme };
    }


    getContactUs(): ContactUsInterface {
        return this.ContactUs;
    }

    getGeneralFeedback(): GeneralFeedbackInterface {
        return this.GeneralFeedback;
    }

    getHeaders(): ScreenHeadings[] {
        return this.Headers;
    }

    getPrimaryButtonText(): string {
        return this.PrimaryButtonText;
    }

    getReportBug(): GeneralFeedbackInterface {
        return this.ReportBug;
    }

    getRequestFeature(): GeneralFeedbackInterface {
        return this.RequestFeature;
    }

    getSecondaryButtonText(): string {
        return this.SecondaryButtonText;
    }

    getcontactUrl(): string {
        return this.contactUrl;
    }

    geticonColor(): string {
        return this.iconColor;
    }

    getratingStyle(): "Star" | "Numbers" | "Smiles" {
        return this.ratingStyle;
    }

    getshowFooter(): boolean {
        return this.showFooter;
    }

    getstarBorderColor(): string {
        return this.starBorderColor;
    }

    getstarColor(): string {
        return this.starColor;
    }
}

export default FeedbackWorkflowFunctions;